import * as React from "react"
import Helmet from "react-helmet"
import { getCurrentLangKey, getLangs, getUrlForLang } from "ptz-i18n"
import { useStateMachine } from "little-state-machine"
import { updateCurrentLanguage } from "../actions/languageActions"

function SEO({
  title,
  description,
  location,
}: {
  title: string
  description?: string
  location: { pathname: string }
}) {
  const { action } = useStateMachine(updateCurrentLanguage)

  const site = {
    siteMetadata: {
      title: `Create React App – Set up a Next.js app by running one command.`,
      description: `Quickly create & run React applications with no build configuration by running only one command.`,
      author: `@bunlongvan`,
      siteUrl: "https://create-next-app.js.org",
      languages: {
        langs: ["en"],
        defaultLangKey: "en",
      },
    },
  }

  const metaDescription = description || site.siteMetadata.description
  const { langs, defaultLangKey } = site.siteMetadata.languages
  const url = location.pathname
  const langKey = getCurrentLangKey(langs, defaultLangKey, url)
  const homeLink = `/${langKey}`.replace(`/${defaultLangKey}/`, "/")

  React.useEffect(() => {
    action(
      getLangs(langs, langKey, getUrlForLang(homeLink, url)).filter(
        ({ selected }) => selected
      )[0].langKey
    )
  }, [])

  return (
    <Helmet
      htmlAttributes={{
        lang: langKey,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content:
            "https://repository-images.githubusercontent.com/164273876/cac6f080-9d19-11ea-83e5-a2983994271e",
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          property: `twitter:image`,
          content:
            "https://repository-images.githubusercontent.com/164273876/cac6f080-9d19-11ea-83e5-a2983994271e",
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]}
    />
  )
}

export default SEO
